import { useState } from 'react'
import StarRating from './StarRating'
import { db } from '@/config/firebase'
import { collection, addDoc, serverTimestamp, updateDoc, doc } from 'firebase/firestore'
import toast from 'react-hot-toast'

interface ReviewFormProps {
    spaceId: string
    userId: string
    userName: string
    bookingId: string
    onReviewSubmitted: () => void
}

export default function ReviewForm({ spaceId, userId, userName, bookingId, onReviewSubmitted }: ReviewFormProps) {
    const [rating, setRating] = useState(0)
    const [comment, setComment] = useState('')
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (rating === 0) {
            toast.error('Por favor, selecione uma nota.')
            return
        }

        setLoading(true)
        try {
            // 1. Criar a review
            await addDoc(collection(db, 'reviews'), {
                spaceId,
                userId,
                userName,
                bookingId,
                rating,
                comment,
                createdAt: serverTimestamp()
            })

            // 2. Atualizar o Booking para marcar que já foi avaliado (evitar duplicidade) - isso pode exigir um campo novo no schema
            await updateDoc(doc(db, 'bookings', bookingId), {
                reviewed: true
            })

            // 3. Atualizar a média do Space (Cloud Function seria melhor, mas faremos cliente-side otimista)
            // Nota: Isso é uma simplificação. O ideal é recalcular com base em todas as reviews.
            // Para "Fase 7", vamos apenas salvar a review por enquanto.

            toast.success('Avaliação enviada com sucesso!')
            onReviewSubmitted()
        } catch (error) {
            console.error('Erro ao enviar avaliação:', error)
            toast.error('Erro ao enviar avaliação.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-2xl border border-gray-100 shadow-lg space-y-4">
            <h3 className="text-lg font-black text-primary uppercase italic tracking-tight">Avaliar Experiência</h3>

            <div className="flex flex-col items-center py-4 bg-gray-50 rounded-xl">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Sua Nota</p>
                <div className="scale-125">
                    <StarRating rating={rating} readOnly={false} onChange={setRating} size={24} />
                </div>
            </div>

            <div>
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-widest mb-2">Comentário (Opcional)</label>
                <textarea
                    className="w-full bg-gray-50 border-none rounded-xl p-4 text-sm focus:ring-2 focus:ring-primary/20 transition-all font-medium"
                    rows={3}
                    placeholder="Conte como foi sua experiência..."
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </div>

            <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#d4a94d] !important text-white py-3 rounded-xl text-xs font-black uppercase tracking-widest hover:bg-[#001c28] transition-all shadow-lg shadow-[#d4a94d]/20 disabled:opacity-100 disabled:bg-gray-300"
            >
                {loading ? 'Enviando...' : 'Enviar Avaliação'}
            </button>
        </form>
    )
}
